import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Platform,
  KeyboardAvoidingView,
  View,
  SafeAreaView,
  RefreshControl,
  TouchableOpacity,
  Text,
} from 'react-native';
import {
  Button,
  ButtonGroup,
} from 'react-native-elements';
import Svg, { Line } from 'react-native-svg';
import { Formik } from 'formik';
import { useSharedValue } from 'react-native-reanimated';
import DraggableFlatList from 'react-native-draggable-flatlist';

import AORTypes from '../../../types';
import Breadcrumb from '../../../../vendor/react-native-breadcrumb';
import {
  translate,
  translateTime,
} from '../../../locales/i18n';
import styles from '../../../styles';
import stylesPublisher from '../../../styles/create';
import EndpointBadge from '../../apps/EndpointBadge';
import Endpoint from '../../../modules/data/Endpoint';
import InfoBlock from '../../InfoBlock';
import App from '../../../modules/data/App';
import Pen from '../../../assets/images/pen.svg';

class PublisherAppFormEndpoints extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleCancel = this.handleCancel.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleAddEndpoint = this.handleAddEndpoint.bind(this);
    this.onMapReady = this.onMapReady.bind(this);
    this.updateRoute = this.updateRoute.bind(this);
    this.setBounds = this.setBounds.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);

    this.state = {
      boundsSet: false,
      refreshing: false,
      indexBeingDragged: -1,
    };
  }

  componentDidMount() {
    const { updateUserData } = this.props;
    updateUserData();
  }

  handleCancel() {
    const { onCancel } = this.props;

    onCancel();
  }

  handleBack(values) {
    const { onSave, onPageSwitch } = this.props;

    onSave(values);
    onPageSwitch(2);
  }

  async handleNext(values, formikBag) {
    const {
      onSave,
      onPageSwitch,
      getAnalyticsService,
    } = this.props;

    formikBag.setSubmitting(true);
    const err = await onSave(values);
    if (err !== null) {
      formikBag.setStatus(err);
      getAnalyticsService().report.event('page3SaveError', 'create');
    } else {
      getAnalyticsService().report.event('page3SaveSuccess', 'create');
    }
    formikBag.setSubmitting(false);

    if (err === null) {
      onPageSwitch(4);
    }
  }

  async handleAddEndpoint(values) {
    const { history, app, onSave } = this.props;

    await onSave(values).then(() => {
      history.push(`/addendpoint/${app.data.uuid}`);
    });
  }

  handleRefresh() {
    const { onRefresh } = this.props;
    this.setState({ refreshing: true });

    onRefresh().then(() => {
      this.setState({ refreshing: false });
    });
  }

  onMapReady(m) {
    console.log('onMapReady');
    // console.log(m); // web debugging only: hangs on iOS
    if (m === null || m === undefined) {
      return;
    }

    const {
      boundsSet,
    } = this.state;

    if (boundsSet) {
      return;
    }

    this.m = m;
    this.setBounds();
  }

  setBounds(boundsParam) {
    let bounds;

    if (boundsParam) {
      bounds = boundsParam;
    } else {
      const { app } = this.props;
      app.postProcess();
      bounds = app.pp.bounds;
    }

    if (!bounds) {
      return;
    }

    const {
      latAvg, lonAvg, latDelta, lonDelta,
    } = bounds;

    const boundsMap = {
      south: latAvg - latDelta / 2.0,
      west: lonAvg - lonDelta / 2.0,
      north: latAvg + latDelta / 2.0,
      east: lonAvg + lonDelta / 2.0,
    };

    // console.log(boundsMap);
    this.setState({ boundsSet: true });
    if (this.m) {
      // need to move the map on the web: no support for deltas in the 'region' prop
      this.m.fitBounds(boundsMap);
    }
  }

  // switchPage(page) {
  //   const {
  //     onPageSwitch,
  //     getAnalyticsService,
  //   } = this.props;
  //   getAnalyticsService().report.event(`page${page}`, 'create');
  //   onPageSwitch(page);
  // }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    isSubmitting,
    status,
  }) => {
    const {
      app,
      history,
      onRefresh,
      onSave,
      userData,
      onPageSwitch,
      getAnalyticsService,
      direction,
    } = this.props;

    const {
      refreshing,
      indexBeingDragged,
    } = this.state;

    const buttons = [
      translate('app_travel_walking'),
      translate('app_travel_cycling'),
      translate('app_travel_driving'),
      translate('app_travel_none'),
    ];

    const endpointsOrdered = [];
    // console.log('uuids to render:');
    app.pp.endpointIds.forEach((uuid) => {
      // console.log(uuid);

      for (let i = 0; i < app.pp.endpoints.length; i += 1) {
        if (app.data.endpoints[i].uuid === uuid) {
          endpointsOrdered.push(app.data.endpoints[i]);
          break;
        }
      }
    });

    if (app && app.data.route === null && !this.updateRouteOnce) {
      console.log('updateRoute() once');
      this.updateRoute(setFieldValue, setFieldTouched);
      this.updateRouteOnce = true;
    }

    const header = (app.pp.endpoints && app.pp.endpoints.length > 1) ? (
      <ButtonGroup
        style={{
          maxWidth: 600,
          alignSelf: 'center',
        }}
        onPress={async (t) => {
          if (t === values.travelType) {
            // no changes
            return;
          }
          getAnalyticsService().report.event(`page3TravelType${t}`, 'create');

          setFieldValue('travelType', t);
          setFieldTouched('travelType');
          app.pp.travelType = t;

          this.updateRoute(setFieldValue, setFieldTouched);
        }}
        selectedIndex={values.travelType}
        buttons={buttons}
        innerBorderStyle={{
          width: 0,
        }}
        containerStyle={{
          borderWidth: 0,
        }}
        selectedButtonStyle={{
          backgroundColor: 'transparent',
          borderWidth: 0,
        }}
        selectedTextStyle={{
          fontFamily: styles.primaryFont700,
          fontWeight: '700',
          fontSize: 14,
          lineHeight: 24,
          color: 'white',
          backgroundColor: '#1FB578',
          borderRadius: 30,
          paddingHorizontal: 20,
          paddingVertical: 4,
        }}
        disabledSelectedTextStyle={{
          fontFamily: styles.primaryFont700,
          fontWeight: '700',
          fontSize: 14,
          lineHeight: 24,
        }}
        buttonStyle={{
          backgroundColor: 'transparent',
          borderWidth: 0,
        }}
        textStyle={{
          fontFamily: styles.primaryFont400,
          fontWeight: '400',
          fontSize: 14,
          lineHeight: 24,
          color: 'black',
          backgroundColor: 'transparent',
          borderRadius: 30,
          paddingHorizontal: 20,
          paddingVertical: 4,
        }}
        disabledTextStyle={{
          fontFamily: styles.primaryFont400,
          fontWeight: '400',
          fontSize: 14,
          lineHeight: 24,
          color: 'black',
          backgroundColor: 'transparent',
        }}

      />
    ) : (
      <></> // eslint-disable-line react/jsx-no-useless-fragment
    );
    const footer = (
      <Button
        title={translate('endpoint_add')}
        containerStyle={styles.button.primaryContainer}
        buttonStyle={styles.button.primary}
        titleStyle={styles.button.primaryTitle}
        onPress={() => this.handleAddEndpoint(values)}
      />
    );

    return (
      <>
        <Breadcrumb
          entities={[
            translate('create_app_app'),
            translate('create_app_guide'),
            translate('create_app_endpoints'),
            translate('create_app_payment'),
            translate('create_app_links'),
            translate('create_app_review'),
          ]}
          isTouchable
          flowDepth={2}
          onCrumbPress={(index) => onPageSwitch(index + 1)}
          borderRadius={3}
          firstCrumbStyle={stylesPublisher.publisherAppEdit.firstCrumbStyle}
          crumbsContainerStyle={
            direction === 'column'
              ? stylesPublisher.publisherAppEdit.crumbsContainerStyle
              : stylesPublisher.publisherAppEdit.crumbsContainerStyleLandscape
          }
        />
        {/* Page 3: Endpoint Info */}
        <KeyboardAvoidingView
          style={[
            styles.form.containerFullScreen,
            { padding: 0, paddingBottom: 0, margin: 0 },
          ]}
          behavior={Platform.OS === 'ios' ? 'padding' : undefined}
        >
          {status !== undefined && (
            <Text
              style={{
                color: 'red',
              }}
            >
              {status}
            </Text>
          )}
          <View style={{
            flex: 1,
            flexDirection: direction,
            width: '100%',
          }}
          >
            {app.pp !== undefined && app.pp.endpoints !== undefined && app.pp.endpoints.length > 0 ? (
              <View
                style={{
                  borderRadius: 8,
                  overflow: 'hidden',
                  // marginLeft: 10,
                  // marginRight: 10,
                  flex: 1,
                  width: 'auto',
                  marginTop: 16,
                }}
              >
                <Text>Map was here</Text>
              </View>
            ) : (
              <InfoBlock>
                {translate('create_app_endpoints_info')}
              </InfoBlock>
            )}
            <View
              style={{
                flex: direction === 'column' ? 2 : 1,
              }}
            >
              <SafeAreaView
                // contentContainerStyle={{ flex: 1 }}
                // containerStyle={{ flex: 1 }}
                style={{
                  flex: 1,
                  marginVertical: 6,
                }}
              >
                <DraggableFlatList
                  data={endpointsOrdered}
                  keyExtractor={(item, _index) => item.uuid}
                  ListHeaderComponent={header}
                  ListFooterComponent={footer}
                  refreshControl={onRefresh !== undefined ? (
                    <RefreshControl
                      refreshing={refreshing}
                      onRefresh={this.handleRefresh}
                    />
                  ) : undefined}
                  renderItem={({
                    item, index, move, moveEnd, isActive,
                  }) => (
                    <>
                      <TouchableOpacity
                        key={item.uuid + isActive ? '1' : '0'}
                        onPress={(e) => {
                          const className = e.target.className.startsWith ? e.target.className : '';
                          // console.log(e);
                          if (Platform.OS !== 'web'
                            || (e.target && !(e.target.nodeName === 'AUDIO'
                              || className.startsWith('triangle')
                              || className.startsWith('right')
                              || className.startsWith('left')
                              || className.startsWith('play_pause')))) {
                            // pressed on something else, not the play button
                            onSave(values).then(() => {
                              history.push(`/editendpoint/${app.data.uuid}/${item.uuid}`);
                            });
                          }
                        }}
                        onLongPress={move}
                        onPressOut={moveEnd}
                      >
                        <EndpointBadge
                          userData={userData}
                          idx={index + 1}
                          endpoint={Endpoint.createFromData(item)}
                          getAnalyticsService={getAnalyticsService}
                          edit
                        />
                        {isActive === false && (() => {
                          // console.log(`drawing index: ${index}`);
                          let before = <></>; // the line upwards from this endpoint
                          let after = <></>; // the line downwards from this endpoint
                          if (index !== 0 && !(indexBeingDragged === 0 && index === 1)) {
                            before = (
                              <Svg style={{ position: 'absolute', left: 24, top: -65 }} width="12" height="90" viewBox="0 0 12 90">
                                <Line
                                  x1="6"
                                  y1="2"
                                  x2="6"
                                  y2="88"
                                  stroke={styles.primaryColor}
                                  strokeWidth={4}
                                  strokeDasharray={[6, 4]}
                                  strokeDashoffset={0}
                                />
                              </Svg>
                            );
                          }
                          if (index !== app.pp.endpoints.length - 1 && !(indexBeingDragged === app.pp.endpoints.length - 1 && index === (indexBeingDragged - 1))) {
                            after = (
                              <Svg style={{ position: 'absolute', left: 24, top: 39 }} width="12" height="90" viewBox="0 0 12 90">
                                <Line
                                  x1="6"
                                  y1="2"
                                  x2="6"
                                  y2="88"
                                  stroke={styles.primaryColor}
                                  strokeWidth={4}
                                  strokeDasharray={[6, 4]}
                                  strokeDashoffset={0}
                                />
                              </Svg>
                            );
                          }
                          return (
                            <>
                              {before}
                              {after}
                            </>
                          );
                        })()}
                      </TouchableOpacity>
                      <View
                        style={{
                          flex: 1,
                          flexDirection: 'row',
                          padding: 0,
                          marginLeft: 38,
                          marginRight: 16, // styles.endpointBadge.panel.marginHorizontal,
                          marginVertical: 10,
                          height: 20,
                          minHeight: 20,
                          maxHeight: 20,
                        }}
                      >
                        {isActive === false && index < endpointsOrdered.length - 1 && (
                          <TouchableOpacity
                            style={{ flexDirection: 'row' }}
                            onPress={() => {
                              history.push(`/editleg/${app.data.uuid}/${item.uuid}/${index}`);
                            }}
                          >
                            <Text
                              key={`${index}-${indexBeingDragged}`}
                              style={{
                                textAlign: 'left',
                                textAlignVertical: 'center',
                                fontStyle: 'italic',
                                paddingRight: 4,
                              }}
                              numberOfLines={1}
                              ellipsizeMode="tail"
                            >
                              ~5 min.
                            </Text>
                            <Pen
                              style={{
                                width: 14,
                                height: 14,
                                alignSelf: 'center',
                              }}
                            />
                          </TouchableOpacity>
                        )}
                        {item.track && (
                          <>
                            <View
                              style={{
                                flex: 1,
                              }}
                            />
                            <View
                              style={{
                                flexDirection: 'row',
                                width: 60, // styles.endpointBadge.blockPlay.width,
                              }}
                            >
                              <Text
                                style={{
                                  flex: 1,
                                  position: 'absolute',
                                  top: -20,
                                  left: 0,
                                  right: 0,
                                  bottom: -20,
                                  textAlign: 'center',
                                  textAlignVertical: 'center',
                                  fontStyle: 'italic',
                                }}
                                numberOfLines={1}
                                ellipsizeMode="tail"
                              >
                                {translateTime(item.duration || 0)}
                              </Text>
                            </View>
                          </>
                        )}
                      </View>
                    </>
                  )}
                  onMoveBegin={(index) => { this.setState({ indexBeingDragged: index }); }}
                  onMoveEnd={({
                    data, _to, _from, _row,
                  }) => {
                    // console.log('uuids after drop:');
                    const endpointIds = [];
                    data.forEach((d) => {
                      // console.log(d.uuid);
                      endpointIds.push(d.uuid);
                    });
                    setFieldValue('endpointIds', JSON.stringify(endpointIds));
                    app.pp.endpointIds = endpointIds;

                    // console.log(`to: ${to}, from: ${from}`);
                    this.setState({ indexBeingDragged: -1 });
                    // TODO(clairbee): optimize away the above state update
                    this.updateRoute(setFieldValue, setFieldTouched);

                    getAnalyticsService().report.event('page3Reorder', 'create');
                  }}
                />
              </SafeAreaView>
            </View>
          </View>
          <View style={styles.form.containerButtons}>
            <Button
              title={translate('button_cancel')}
              containerStyle={styles.button.secondaryContainer}
              buttonStyle={styles.button.secondary}
              disabledStyle={styles.button.secondaryDisabled}
              titleStyle={styles.button.secondaryTitle}
              disabledTitleStyle={styles.button.secondaryTitleDisabled}
              onPress={this.handleCancel}
            />
            <Button
              title={translate('button_prev')}
              containerStyle={styles.button.primaryContainer}
              buttonStyle={styles.button.primary}
              disabledStyle={styles.button.primaryDisabled}
              titleStyle={styles.button.primaryTitle}
              disabledTitleStyle={styles.button.primaryTitleDisabled}
              onPress={() => this.handleBack(values)}
              disabled={!isValid || isSubmitting}
              loading={isSubmitting}
              loadingProps={{ size: 'small', color: 'white' }}
            />
            <Button
              title={translate('button_next')}
              containerStyle={styles.button.primaryContainer}
              buttonStyle={styles.button.primary}
              disabledStyle={styles.button.primaryDisabled}
              titleStyle={styles.button.primaryTitle}
              disabledTitleStyle={styles.button.primaryTitleDisabled}
              onPress={handleSubmit}
              disabled={!isValid || isSubmitting}
              loading={isSubmitting}
              loadingProps={{ size: 'small', color: 'white' }}
            />
          </View>
        </KeyboardAvoidingView>
      </>
    );
  };

  render() {
    const { app } = this.props;

    app.postProcess();

    return (
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={{
          endpointIds: app.data.endpointIds ? app.data.endpointIds : '[]',
        }}
        onSubmit={(values, formikBag) => this.handleNext(values, formikBag)}
      // validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

PublisherAppFormEndpoints.defaultProps = {
  onRefresh: undefined,
  direction: 'column',
};

PublisherAppFormEndpoints.propTypes = {
  userData: AORTypes.User.isRequired,
  app: PropTypes.instanceOf(App).isRequired,
  onCancel: PropTypes.func.isRequired,
  onPageSwitch: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onRefresh: PropTypes.func,
  updateUserData: PropTypes.func.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string,
};

export default PublisherAppFormEndpoints;
